<template>
    <div class="select page-color" :class="'level' + currentLevel">

        <header-back :definition="definition"></header-back>

        <div class="container">

            <h3 class="level-header"> LEVEL {{currentLevel}}
                <p> {{total - copyVerbs.length}} / {{total}} </p>
            </h3>

            <div class="container-selection" v-if="copyVerbs.length > 0">
                <selection-card :selected="selectedTense"
                                :verb="verb"
                                :focus="focus"
                                :disabled="true"
                ></selection-card>
                <button class="clean" :class="{disabled: this.verb.infinitive === '' || tryAgain}" @click="clear()">⤫</button>
                <button class="correct" :class="{disabled: !correct}" @click="clear()">✔</button>

            </div>
            <div v-else class="endGame">
                CONGRATULATIONS
                <button @click="startAgain()">
                    Try Again
                    <span>↻</span>
                </button>
            </div>

            <div class="container-options">
                <ul>
                    <li v-for="(item, index) in optionsRandom" v-bind:key="index"
                        :ref="'option_' + index"
                        @click="selectVerb(item)"
                        :class="{selected: item.selected}">
                        {{item.value}}
                    </li>
                </ul>

                <transition name="fade">
                    <div v-if="tryAgain" class="correction">
                        <div>
                            <h4>Correct Answer</h4>
                            <p>
                                <span>{{selected.infinitive}}</span>
                                <span>{{selected.simplePast}}</span>
                                <span>{{selected.pastParticiple}}</span>
                            </p>
                        </div>
                        <button @click="clear()">
                            Try Again
                            <span>↻</span>
                        </button>
                    </div>

                    <div v-if="correct" class="correction correct">
                        <div>
                            <h2>Well Done</h2>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import headerBack from '../components/Header';
    import irregularVerbsData from '../data/irregularVerbs';
    import selectionCard from '../components/SelectionCard';

    export default {
        data(){
            return {
                irregularVerbs: irregularVerbsData.IrregularVerbs,
                selected: null,
                selectedTense: null,
                options: [],
                optionsRandom: [],
                copyVerbs: [],
                verb: {
                    infinitive: "",
                    simplePast: "",
                    pastParticiple: ""
                },
                definition: null,
                tryAgain: false,
                position: null,
                correct: false,
                currentLevel: this.$route.params.id,
                total: 0
            }
        },
        created() {
            let vm = this;
            //this.copyVerbs = this.irregularVerbs.slice(0);
            this.copyVerbs = this.irregularVerbs.filter(function(value) {
                return value.level === vm.currentLevel;
            });
            this.total = this.copyVerbs.length;
            this.selectNewVerb();
        },
        components: {
            headerBack,
            selectionCard
        },
        methods: {
            clear() {
                for (let i = 0; i < this.optionsRandom.length; i++ ){
                    this.optionsRandom[i].selected = false;
                }

                this.verb = {
                    infinitive: "",
                    simplePast: "",
                    pastParticiple: ""
                };

                this.tryAgain = false;
                this.correct = false;
                this.total = this.copyVerbs.length;
            },
            getPosition(){

                this.clear();
                this.options = [];
                this.optionsRandom = [];

                this.position = Math.floor(Math.random() * this.copyVerbs.length);
                this.selected = this.copyVerbs[this.position];
                let randomTense = Math.floor(Math.random() * 3);
                switch (randomTense) {
                    case 0:
                        this.selectedTense = this.selected.infinitive;
                        break;
                    case 1:
                        this.selectedTense = this.selected.simplePast;
                        break;
                    case 2:
                        this.selectedTense = this.selected.pastParticiple;
                        break;
                    default:
                        this.selectedTense = this.selected.infinitive;
                        break;
                }

                this.definition = this.selected.definition;
                this.options.push({value: this.selected.infinitive});
                this.options.push({value: this.selected.simplePast});
                this.options.push({value: this.selected.pastParticiple});

                //this.copyVerbs.slice(this.position, 1);
            },
            getRandomVerbs(){
                let random = Math.floor(Math.random() * this.irregularVerbs.length);
                let verb = this.irregularVerbs[random];
                let randomVerb;
                let random2 = Math.floor(Math.random() * 3);
                switch (random2) {
                    case 0:
                        randomVerb = verb.infinitive;
                        break;
                    case 1:
                        randomVerb = verb.simplePast;
                        break;
                    case 2:
                        randomVerb = verb.pastParticiple;
                        break;
                    default:
                        randomVerb = verb.infinitive;
                        break;
                }

                this.options.push({value: randomVerb});
            },
            selectNewVerb(){
                this.getPosition();

                for (let i = 0 ; i < 6; i++){
                    this.getRandomVerbs();
                }

                this.optionsRandom = this.shuffle(this.options);

            },
            shuffle(array){
                for (let i = array.length - 1; i > 0; i--) {
                    let j = Math.floor(Math.random() * (i + 1));
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                }
                return array;
            },
            selectVerb(item){

                item.selected = true;

                if (this.verb.infinitive === ""){
                    this.verb.infinitive = item.value;

                } else if (this.verb.simplePast === "") {
                    this.verb.simplePast = item.value;

                } else {
                    this.verb.pastParticiple = item.value;
                    this.compareVerbs();
                }
            },
            compareVerbs(){
                if (this.selected.infinitive === this.verb.infinitive
                    && this.selected.simplePast === this.verb.simplePast
                    && this.selected.pastParticiple === this.verb.pastParticiple){

                    this.copyVerbs.splice(this.position, 1);
                    this.correct = true;

                    let self = this;
                    setTimeout(function(){
                        self.selectNewVerb();
                    }, 600);

                } else {
                    this.tryAgain = true;
                }
            },
            startAgain(){
                this.copyVerbs = this.irregularVerbs.slice(0);
                this.selectNewVerb();
            }
        },
        computed: {
            focus(){
                if (this.verb.infinitive === ""){
                    return 0;

                } else if (this.verb.simplePast === "") {
                    return 1;

                } else {
                    return 2;

                }
            }
        }
    }
</script>